class Controller {
  constructor(
    $injector,
    Events,
    $mdDialog,
    GoogleMaps,
    officeLocationDetails,
    corporateId,
    reUpdateOfficeLocationsEvent
  ) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.googleMapsUrl = GoogleMaps.getSource();
    this.officeLocationDetails = {
      name: { value: officeLocationDetails.name, isDisabled: true },
      coords: {
        value: officeLocationDetails.coords,
        isDisabled: true,
      },
    };
    this.officeLocationId = officeLocationDetails._id;
    this.Corporate = $injector.get("Corporate");
    this.Messages = $injector.get("Messages");
    this.corporateId = corporateId;
    this.Events = Events;
    this.updateOfficeLocationEvent = Events.updateOfficeLocationEvent(
      "office_location"
    );
    this.successEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorEvent = this.Events.eventsType.onShowErrorNotification;
    this.reUpdateOfficeLocationsEvent = reUpdateOfficeLocationsEvent;
  }
  $onInit() {
    this.updateOfficeLocation = () => {
      let coords;
      if (!Array.isArray(this.officeLocationDetails.coords.value)) {
        const latlng = this.officeLocationDetails.coords.value.split(",");
        coords = {
          lng: latlng[0],
          lat: latlng[1],
        };
      } else {
        coords = {
          lng: this.officeLocationDetails.coords.value[0],
          lat: this.officeLocationDetails.coords.value[1],
        };
      }
      const name = this.officeLocationDetails.name.value;
      this.Corporate.updateOfficeLocation(this.corporateId, {
        officeLocationId: this.officeLocationId,
        coords,
        name,
      }).$promise.then(
        () => {
          this.Events.emit(
            this.successEvent,
            this.Messages.updateMessage("Corporate office location")
          );
          this.Events.emit(this.reUpdateOfficeLocationsEvent);
        },
        (response) => this.Events.emit(this.errorEvent, response.data)
      );
    };

    this.Events.on(this.updateOfficeLocationEvent, this.updateOfficeLocation);
  }

  close() {
    this.$mdDialog.hide();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporate/officeLocationDetailsDialog/officeLocationDetailsDialog.controller.js